module.exports = __webpack_public_path__ + "img/img-lock.654f196b.png";